import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useState, useEffect } from "react";
import Register from "./pages/Register";
import Login from "./pages/Login";
import PrivateRoute from "./components/PrivateRoute";
import Home from "./pages/Home";
import { Box } from "@chakra-ui/react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { ApplicationContext } from "./utils/contextsProviders";
import CustomerUsers from "./components/CustomerUsers";
import { jwtDecode } from "jwt-decode";
import CustomerAdminPrivateRoute from "./components/CustomerAdminPrivateRoute";
import { isTokenExpired } from "./utils/auth";
import SessionWatcher from "./components/SessionWatcher";

const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    if (isTokenExpired(token)) {
      localStorage.removeItem("token");
      setUser(null);
      return;
    }

    const decoded = jwtDecode(token);
    setUser(decoded.user);
  }, [user?.role]);

  return (
    <ApplicationContext.Provider value={{ user, setUser }}>
    <Router>
      <SessionWatcher />
      <Box minHeight="100vh" display="flex" flexDirection="column">
        <Header />
        <Box flex="1">
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
             <Route
              path="/users"
              element={
                <PrivateRoute>
                  <CustomerAdminPrivateRoute>
                     <CustomerUsers/>
                  </CustomerAdminPrivateRoute>
                </PrivateRoute>
              }
            />
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/login" element={<Login />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </Router>
    </ApplicationContext.Provider>
  );
};

export default App;
